module.exports = __webpack_public_path__ + "static/media/report_16-20_desktop.329f74a6.png";